export const getSettings = state => state;
export const getSetting = (state, key) => state[key];
//# sourceMappingURL=selectors.js.map